export default __webpack_public_path__ + "static/media/ttmikbooks_01.e7c1d351.jpg";